// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"3344":"vendors/vendors--db.json","3819":"vendors/vendors-~-consoleHook-59e792cb.mjs","3912":"vendors/vendors--index.mjs","7480":"vendors/vendors--main.js"}[chunkId] || chunkId) + ".bundle.js";
};